import { useLearnerMessages } from '@/features/messages/hooks/useMessages'
import { formatDistanceToNow } from 'date-fns'
import { ko } from 'date-fns/locale'
import { Link } from 'react-router-dom'

export default function LearnerMessagesPage() {
  const { data, isLoading } = useLearnerMessages()

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    )
  }

  const messages = data?.messages ?? []

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">받은 메시지</h1>

      {messages.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          받은 메시지가 없습니다
        </div>
      ) : (
        <div className="space-y-2">
          {messages.map((msg) => (
            <Link
              key={msg.id}
              to={`/messages/${msg.id}`}
              className={`block p-4 rounded-lg border hover:border-blue-300 transition-colors ${
                msg.isRead ? 'bg-white border-gray-200' : 'bg-blue-50 border-blue-200'
              }`}
            >
              <div className="flex items-start gap-3">
                <span className={`mt-2 w-2 h-2 rounded-full flex-shrink-0 ${
                  msg.isRead ? 'bg-gray-300' : 'bg-blue-500'
                }`} />
                <div className="flex-1 min-w-0">
                  <div className="flex justify-between items-start gap-2">
                    <h3 className="font-medium truncate">{msg.title}</h3>
                    <span className="text-xs text-gray-500 whitespace-nowrap">
                      {formatDistanceToNow(new Date(msg.createdAt), {
                        addSuffix: true,
                        locale: ko
                      })}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    {msg.senderName}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
